import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import ProtectedRoute from './components/ProtectedRoute';
import ClientProtectedRoute from './components/ClientProtectedRoute';
import { Toaster } from "./components/ui/sonner.jsx";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Imposta l'URL di base per tutte le richieste axios
axios.defaults.baseURL = import.meta.env.VITE_API_URL;

// --- Lazy Load delle Pagine ---
const AdminDashboard = React.lazy(() => import('./pages/AdminDashboard'));
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const AdminLoginPage = React.lazy(() => import('./pages/AdminLoginPage'));
const ClientDashboard = React.lazy(() => import('./pages/ClientDashboard'));
const StoricoPunti = React.lazy(() => import('./pages/StoricoPunti'));
const ModificaProfiloPage = React.lazy(() => import('./pages/ModificaProfiloPage'));
const GestioneDocumenti = React.lazy(() => import('./pages/GestioneDocumenti'));
const DocumentPage = React.lazy(() => import('./pages/DocumentPage'));
const SetPasswordPage = React.lazy(() => import('./pages/SetPasswordPage'));

// Imposta axios per inviare sempre i cookie con le richieste
axios.defaults.withCredentials = true;

// Componente da mostrare durante il caricamento delle pagine
const LoadingFallback = () => (
  <div style={{ textAlign: 'center', padding: '50px' }}>
    Caricamento...
  </div>
);

function App() {
  const recaptchaKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

  const routerContent = (
    <Router>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/admin" element={<Navigate to="/admin/login" />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/documenti" element={<ProtectedRoute><GestioneDocumenti /></ProtectedRoute>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/imposta-password" element={<SetPasswordPage />} />
          <Route path="/dashboard" element={<ClientProtectedRoute><ClientDashboard /></ClientProtectedRoute>} />
          <Route path="/storico-punti" element={<ClientProtectedRoute><StoricoPunti /></ClientProtectedRoute>} />
          <Route path="/modifica-profilo" element={<ClientProtectedRoute><ModificaProfiloPage /></ClientProtectedRoute>} />
          <Route path="/regolamento" element={<DocumentPage slug="regolamento" />} />
          <Route path="/privacy-policy" element={<DocumentPage slug="privacy-policy" />} />
          <Route path="/cookie-policy" element={<DocumentPage slug="cookie-policy" />} />
        </Routes>
      </Suspense>
      <Toaster richColors position="top-center" duration={3000} />
    </Router>
  );

  if (recaptchaKey) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
        {routerContent}
      </GoogleReCaptchaProvider>
    );
  }

  return routerContent;
}

export default App;